"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContractListProductsResponseSchema = exports.AdminContractGetProductResponseSchema = exports.AdminContractProductIdPathParamsSchema = exports.AdminContractListProductsQueryParamsSchema = exports.AdminContractUpdateProductRequestSchema = exports.AdminContractCreateProductRequestSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const schema_builder_1 = require("../../../shared/schema-builder");
const ProductSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    collectionId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    deletedAt: zod_1.z.coerce.date().nullable(),
    restockedAt: zod_1.z.coerce.date().nullable(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
    skuNo: zod_1.z.string(),
    coverImage: zod_1.z.string(),
    images: zod_1.z.string().array(),
    description: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    price: zod_1.z.number(),
    priceUsd: zod_1.z.number(),
    stock: zod_1.z.number().int(),
    isAvailable: zod_1.z.boolean(),
    frameShape: zod_1.z.string().nullable(),
    frameColor: zod_1.z.string().nullable(),
    lensColor: zod_1.z.string().nullable(),
    isPolarized: zod_1.z.boolean(),
});
exports.AdminContractCreateProductRequestSchema = ProductSchema.pick({
    skuNo: true,
    name: true,
    coverImage: true,
    images: true,
    description: true,
    stock: true,
    price: true,
    priceUsd: true,
    collectionId: true,
    isAvailable: true,
    frameShape: true,
    frameColor: true,
    lensColor: true,
    isPolarized: true,
});
exports.AdminContractUpdateProductRequestSchema = exports.AdminContractCreateProductRequestSchema;
exports.AdminContractListProductsQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema.extend({
    collectionId: shared_1.UUIDSchema.optional(),
    sortBy: zod_1.z.string().default('name|asc'),
    frameColor: zod_1.z.string().optional(),
    frameShape: zod_1.z.string().optional(),
    lensColor: zod_1.z.string().optional(),
    isPolarized: shared_1.BooleanQueryParamSchema.optional(),
    onlyDiscount: shared_1.BooleanQueryParamSchema.optional(),
});
exports.AdminContractProductIdPathParamsSchema = zod_1.z.object({ productId: shared_1.UUIDSchema });
const AdminContractProductSchema = new schema_builder_1.SchemaBuilder(ProductSchema)
    .replaceDateField('createdAt')
    .replaceDateField('updatedAt')
    .extend({ collectionName: zod_1.z.string() })
    .build();
exports.AdminContractGetProductResponseSchema = zod_1.z.object({ product: AdminContractProductSchema });
exports.AdminContractListProductsResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({ products: AdminContractProductSchema.array() });
